import React, { useState } from 'react';
import AdminLayout from '../../components/layout/AdminLayout';
import toast from 'react-hot-toast';

export default function ClientsPage() {
  const [clients] = useState([
    { id:1, name:"Zeva2 Main", module:"Agri", domain:"zevazeva.com", users:150, status:"active", adminMobile:"9000000000" },
  ]);
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({ name:"", module:"agri", domain:"", adminMobile:"", adminName:"" });

  const addClient = () => {
    if (!form.name || !form.domain || !form.adminMobile) return toast.error("Fill all required fields");
    toast.success("Client " + form.name + " created! (Demo)");
    setShowAdd(false);
  };

  return (
    <AdminLayout title="Client Management">
      <div className="flex-between" style={{ marginBottom:16 }}>
        <div style={{ fontSize:13, color:"#6C757D" }}>{clients.length} clients</div>
        <button className="btn btn--primary" onClick={() => setShowAdd(true)}>➕ Add Client</button>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))", gap:16 }}>
        {clients.map(c => (
          <div key={c.id} className="card">
            <div className="card__body">
              <div className="flex-between" style={{ marginBottom:10 }}>
                <div style={{ fontWeight:700, fontSize:15 }}>{c.name}</div>
                <span className={"badge "+(c.status==="active"?"badge--success":"badge--danger")}>{c.status}</span>
              </div>
              <div style={{ fontSize:12, color:"#6C757D", marginBottom:8 }}>
                🌐 {c.domain}<br/>📦 Module: {c.module}<br/>👥 {c.users} users<br/>📱 Admin: +91 {c.adminMobile}
              </div>
              <div style={{ display:"flex", gap:8 }}>
                <button className="btn btn--outline btn--sm btn--full">⚙️ Manage</button>
                <button className="btn btn--primary btn--sm btn--full">📊 Stats</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {showAdd && (
        <div className="modal-overlay" onClick={() => setShowAdd(false)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <div className="modal__header">
              <div className="modal__title">➕ Add New Client</div>
              <button className="modal__close" onClick={() => setShowAdd(false)}>×</button>
            </div>
            <div className="modal__body">
              {[
                { k:"name",        label:"Client Name *",        type:"text",  placeholder:"e.g. Green Nursery Karnataka" },
                { k:"domain",      label:"Domain *",             type:"text",  placeholder:"e.g. nursery.zevazeva.com" },
                { k:"adminMobile", label:"Admin Mobile *",       type:"tel",   placeholder:"Admin mobile number" },
                { k:"adminName",   label:"Admin Name *",         type:"text",  placeholder:"Admin full name" },
              ].map(f => (
                <div key={f.k} className="form-group">
                  <label className="label">{f.label}</label>
                  <input className="input" type={f.type} placeholder={f.placeholder}
                    value={form[f.k]} onChange={e=>setForm(p=>({...p,[f.k]:e.target.value}))} />
                </div>
              ))}
              <div className="form-group">
                <label className="label">Module</label>
                <select className="input" value={form.module} onChange={e=>setForm(p=>({...p,module:e.target.value}))}>
                  <option value="agri"> Agri</option>
                  <option value="nursery"> Nursery</option>
                  <option value="ecommerce">🛒 eCommerce</option>
                  <option value="organic"> Organic</option>
                </select>
              </div>
            </div>
            <div className="modal__footer">
              <button className="btn btn--outline" onClick={() => setShowAdd(false)}>Cancel</button>
              <button className="btn btn--primary" onClick={addClient}>Create Client</button>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
